module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/auth/auth.component.scss
// module id = ./src/app/layouts/auth/auth.component.scss
// module chunks = main